import { BaseContainerModel } from "../../base-container.model";
import { alg_bot_cf_conversation_instance_hdr_RowClass } from "../../../dbschema";

export class BotCfConversationInstanceHdrContainerModel extends BaseContainerModel {
  alg_bot_cf_conversation_instance_hdr: alg_bot_cf_conversation_instance_hdr_RowClass = new alg_bot_cf_conversation_instance_hdr_RowClass();
}
